<template>
    <div class="home-header border-bottom border-top">
        <b-container>
            <b-row
                align-v="center"
                class="py-3 text-center text-sm-left"
            >
                <b-col
                    cols="12"
                    md="3"
                    lg="2"
                    class="mb-5 mb-md-0"
                >

                    <b-img
                        v-if="landingPage.avatar"
                        :src="landingPage.avatar.publicStorageUrl"
                        class="avatar"
                    />
                    <div
                            v-else
                            class="avatar-wrapper"
                    >
                        <div class="avatar alert-primary">
                            {{ `${landingPage.firstName} ${landingPage.lastName}` | initials(2) }}
                        </div>
                    </div>

                </b-col>

                <b-col
                    cols="12"
                    md="6"
                    lg="7"
                >
                    <p class="mb-0 agent-name">
                        {{ name }}
                    </p>

                    <p class="mb-0 agent-role">
                        Real Estate Agent
                    </p>
                </b-col>

                <b-col
                    cols="12"
                    md="3"
                    class="action-btn-col"
                >
                    <b-button
                        variant="primary"
                        class="action-btn w-100 py-3"
                        @click="handleShowGetStartedModal"
                    >
                        {{ actionButtonText }}
                    </b-button>
                </b-col>

                <b-col
                    v-if="isMobile"
                    cols="12"
                    class="mt-3"
                >
                    <agent-contact-info
                        :landing-page="landingPage"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import './HomeHeader.scss';
    import './HomeHeader.mobile.scss';
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import {DEFAULT_AVATAR} from "../../../../helpers/images";
    import LandingPageHomeSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHomeSectionAppResource";
    import AgentContactInfo from "../AgentContactInfo/AgentContactInfo";
    import {showInterstitialModal, INTERSTITIAL_MODAL_TYPES} from "../../../../helpers/modals";

    export default {
        name: "HomeHeader",
        components: {AgentContactInfo},

        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true,
            },

            homeSection: {
                type: LandingPageHomeSectionAppResource,
                required: true,
            },

            isMobile: {
                type: Boolean,
                required: true,
            },
        },

        methods: {
            handleShowGetStartedModal() {
                showInterstitialModal(
                    INTERSTITIAL_MODAL_TYPES.GET_STARTED,
                    {
                        firstName: this.landingPage.firstName,
                        lastName: this.landingPage.lastName,
                        displayName: this.landingPage.displayName,
                        avatar: this.landingPage.avatar,
                    },
                    {
                        landingPageUuid: this.landingPage.uuid,
                    }
                );
            }
        },

        computed: {
            avatarImg() {
                return (this.landingPage.avatar || {}).publicStorageUrl || DEFAULT_AVATAR;
            },

            name() {
                return this.landingPage.displayName
                    || [this.landingPage.firstName, this.landingPage.lastName].join(' ');
            },

            actionButtonText() {
                return this.homeSection.actionButtonText;
            },

        }
    };
</script>
